import { render, staticRenderFns } from "./CompanyName.vue?vue&type=template&id=71747d6e"
import script from "./CompanyName.vue?vue&type=script&lang=js"
export * from "./CompanyName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports